const THOUSAND = 1_000;
const MILLION = 1_000_000;
/** Compact metric formatting (1.2K / 3.4M) shared by the Discover card and profile overlay stats. */
const formatDiscoverChatbotCardCount = (value) => {
    if (!value || value <= 0) {
        return "0";
    }
    if (value >= MILLION) {
        return `${(value / MILLION).toFixed(1)}M`;
    }
    if (value >= THOUSAND) {
        return `${(value / THOUSAND).toFixed(1)}K`;
    }
    return `${value}`;
};
export default formatDiscoverChatbotCardCount;
